/**
 * Remembers that the API rejected a request with 401 ACCOUNT_DELETED: the
 * signed-in account was deleted (its access token is still valid for up to an
 * hour, but the backend refuses it). apiClient marks it; AuthProvider
 * subscribes and signs the user out (ProtectedRoute then shows the login
 * page), and LoginPage shows a translated notice. The flag lasts for the page
 * session and is cleared by the next successful login.
 */
type Listener = () => void;

let accountDeleted = false;
const listeners = new Set<Listener>();

export const ACCOUNT_DELETED_CODE = 'ACCOUNT_DELETED';

export function markAccountDeleted(): void {
  if (accountDeleted) return;
  accountDeleted = true;
  listeners.forEach((listener) => listener());
}

export function isAccountDeleted(): boolean {
  return accountDeleted;
}

/** Called after a successful login (e.g. a new account registered with the same e-mail). */
export function clearAccountDeleted(): void {
  if (!accountDeleted) return;
  accountDeleted = false;
  listeners.forEach((listener) => listener());
}

export function subscribeAccountDeleted(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
